import React, { memo, useCallback, useContext } from 'react'
import { DndProvider, useDrag, useDrop } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import UserContext from '../../services/user/user'
import update from 'immutability-helper'
import { Box } from '@mui/material'

const WidgetsOrderController = memo(function WidgetsOrderController() {
    const { widgetsList, setWidgetsList } = useContext(UserContext);

    const findCard = useCallback((id) => {
        const card = widgetsList.filter((c) => `${c.id}` === id)[0];
        return {
            card,
            index: widgetsList.indexOf(card),
        };
    }, [widgetsList]);

    const moveCard = useCallback((id, atIndex) => {
        const { card, index } = findCard(id);
        setWidgetsList(update(widgetsList, {
            $splice: [
                [index, 1],
                [atIndex, 0, card],
            ],
        }));
    }, [findCard, widgetsList, setWidgetsList]);

    const [, drop] = useDrop(() => ({ accept: 'widget' }));

    return (
        <Box ref={drop} sx={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gridGap: 16, mb: 3}}>
            {widgetsList.map((card) => (<Card key={card.id} id={`${card.id}`} card={card} moveCard={moveCard} findCard={findCard} />))}
        </Box>
    )
});

const cardStyle = {
    border: '1px dashed gray',
    padding: '0.5rem 1rem',
    marginBottom: '.5rem',
    backgroundColor: 'white',
    cursor: 'move',
};
const Card = memo(function Card({ id, card, moveCard, findCard, }) {
    const originalIndex = findCard(id).index;

    const [{ isDragging }, drag] = useDrag(() => ({
        type: 'widget',
        item: { id, originalIndex },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        end: (item, monitor) => {
            const { id: droppedId, originalIndex } = item;
            const didDrop = monitor.didDrop();
            if (!didDrop) {
                moveCard(droppedId, originalIndex);
            }
        },
    }), [id, originalIndex, moveCard]);

    const [, drop] = useDrop(() => ({
        accept: 'widget',
        hover({ id: draggedId }) {
            if (draggedId !== id) {
                const { index: overIndex } = findCard(id);
                moveCard(draggedId, overIndex);
            }
        },
    }), [findCard, moveCard]);

    const opacity = isDragging ? 0.5 : 1;
    const cursor = isDragging ? 'grab' : 'grab';
    return (
        <div ref={(node) => drag(drop(node))} style={{ opacity, cursor }} className={card.size}>
            <img src={card.image} className='img-fluid'/>
            {/* {card.component} */}
        </div>
    )
});


export default WidgetsOrderController;